import { render, staticRenderFns } from "./metrics_custom_report_view.vue?vue&type=template&id=5c0dc36c&scoped=true&"
import script from "./metrics_custom_report_view.vue?vue&type=script&lang=js&"
export * from "./metrics_custom_report_view.vue?vue&type=script&lang=js&"
import style0 from "./metrics_custom_report_view.vue?vue&type=style&index=0&id=5c0dc36c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0dc36c",
  null
  
)

export default component.exports